import { toast } from "react-hot-toast";

export const toastError = (message, setPlans) => {
  const errorMessage = message?.response?.data?.message
    ? message?.response?.data?.message
    : message?.response?.data?.detail
    ? message?.response?.data?.detail
    : message?.message
    ? message?.message
    : message;

  if (
    errorMessage === "Internal error: 'NoneType' object is not subscriptable"
  ) {
    setPlans(0);
    localStorage.setItem("chat-step", 0);
    return;
  }
  toast.error(errorMessage || "Something went wrong.");
};
